import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TaskCard, TaskContent } from 'features/task-management';
import { RoomTimer, PsiRoomTimer } from 'shared/components';
import './TaskSection.scss';

const TaskSection = (props) => {
  const { t } = useTranslation();
  const {
    upcomingTasks,
    roomId,
    taskActions,
    isPsiEvent,
    setIsUpdateStatus,
    setIsAutoRefreshStarted,
    isAutoRefreshStartedRef,
  } = props;
  const [currentTask, setCurrentTask] = useState({});
  const [taskCardOpen, setTaskCardOpen] = useState(false);
  const [loadingCompleteTask, setLoadingCompleteTask] = useState(false);
  const [completeTaskErrorMessage, setCompleteTaskErrorMessage] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentTask(upcomingTasks[0]);
  }, [upcomingTasks]);

  const toggleTaskModal = () => {
    setTaskCardOpen(!taskCardOpen);
  };

  const onSubmitTask = async () => {
    setLoadingCompleteTask(true);
    const completedTask = await dispatch(taskActions.setCompleteTask(roomId, currentTask));
    setLoadingCompleteTask(false);

    if (!completedTask.id) {
      setCompleteTaskErrorMessage(completedTask.data.message);
      if (completedTask.status === 400) {
        dispatch(taskActions.getRoomStatus(roomId));
      }
    }

    toggleTaskModal();
  };

  const removeErrorMessage = () => {
    setCompleteTaskErrorMessage('');
  };

  return (
    <div className="task-section">
      {isPsiEvent ? (
        <PsiRoomTimer
          displaySmallTimer
          location={window.location.pathname}
          isPsiEvent
          setIsUpdateStatus={setIsUpdateStatus}
          setIsAutoRefreshStarted={setIsAutoRefreshStarted}
          isAutoRefreshStartedRef={isAutoRefreshStartedRef}
        />
      ) : (
        <RoomTimer displaySmallTimer location={window.location.pathname} />
      )}
      {currentTask && (
        <TaskCard
          active
          smallTaskCard
          task={currentTask}
          renderTask={toggleTaskModal}
          details={t('taskManagement.currentTask')}
        />
      )}
      <TaskContent
        task={{ ...currentTask, active: true }}
        loadingCompleteTask={loadingCompleteTask}
        alreadyCompletedMessage={completeTaskErrorMessage}
        modalOpen={taskCardOpen}
        toggleModal={toggleTaskModal}
        submitTask={onSubmitTask}
        removeCompleted={removeErrorMessage}
      />
    </div>
  );
};

export default TaskSection;
